export default __webpack_public_path__ + "static/media/error_background.c353d1e1.png";